import React, { Fragment, useState, useEffect } from "react";
import Countdown from "react-countdown";

const LiveCountdown = (props) => {
  const { startDate, endDate, isOngoing } = props;

  if (isOngoing) {
    return (
      <div className="live-countdown">
        {new Date(startDate) > Date.now() ? "" : "LIVE"}
      </div>
    );
  }

  const renderer = (props) => {
    return (
      <Fragment>
        <div className="countdown-number">
          <span aria-label="Days remaining">{props.formatted.days}</span>
          <span className="countdown-letters">DAYS</span>
        </div>
        :
        <div className="countdown-number">
          <span aria-label="Hours remaining">{props.formatted.hours}</span>
          <span className="countdown-letters">HOURS</span>
        </div>
        :
        <div className="countdown-number">
          <span aria-label="Minutes remaining">{props.formatted.minutes}</span>
          <span className="countdown-letters">MINUTES</span>
        </div>
        :
        <div className="countdown-number">
          <span aria-label="Seconds remaining">{props.formatted.seconds}</span>
          <span className="countdown-letters">SECONDS</span>
        </div>
      </Fragment>
    );
  };
  return (
    <div className="live-countdown">
      <Countdown date={endDate} renderer={renderer} />
    </div>
  );
};

export default LiveCountdown;
